<template>
  <div>
    <vs-popup :title="$t('CreateSerial')" :active.sync="showModal">
      <vs-tabs vs-alignment="fixed" alignment="fixed" ref="Tabs">
        <vs-tab :label="$t('CreateSerial')" class="mt-2">
          <show-serials-list-popup
            :modelForShowCurrent="modelForShowCurrent"
            @finish="finish"
          >
          </show-serials-list-popup>
        </vs-tab>
        <vs-tab :label="$t('AvailableSerials')" class="mt-2">
          <add-serials-partial-popup
            v-if="isShowTabGridSerials"
            :modelForInternalApi="modelForInternalApi"
            :lastIndexRegistered="lastIndexRegistered"
            :modelForShowCurrent="modelForShowCurrent"
          ></add-serials-partial-popup>
        </vs-tab>
      </vs-tabs>
    </vs-popup>
  </div>
</template>

<style lang="scss">
.vs-con-input input {
  text-align: right;
}
.custom-tbl td {
  padding: 0.5rem 1rem !important;
}
</style>

<script>
import { Validator } from "vee-validate";
import AddSerialsPartialPopup from "./AddSerialsPartialPopup.vue";
import ShowSerialsListPopup from "./ShowSerialsListPopup.vue";

const dict = {
  custom: {
    serialName: {
      required: "لطفا شماره سریال را وارد نمایید.",
      regex: "شماره سریال معتبر نمی باشد"
    }
  }
};
Validator.localize("fa", dict);
export default {
  name: "warehouseManagement_CheckOutTransactions_DischargeCheckoutSerialPopup",
  components: {
    AddSerialsPartialPopup,
    ShowSerialsListPopup
  },
  props: {
    show: { default: false },
    modelForInternalApi: { default: {} },
    modelForShowCurrent: { default: {} },
    lastIndexRegistered: { default: 0 }
  },
  computed: {
    showModal: {
      get: function() {
        return this.show;
      },
      set: function() {
        this.$emit("finish", "", "notNew");
        this.$validator.reset();
      }
    }
  },
  data() {
    return {
      isShowTabGridSerials: true
    };
  },
  methods: {
    finish(data, type) {
      this.$emit("finish", data, type);
    }
  },
  watch: {
    show() {
      if (this.show) {
        this.isShowTabGridSerials = false;
        setTimeout(() => {
          this.isShowTabGridSerials = true;
        }, 150);
      }
    }
  }
};
</script>
